import React from 'react';
import { Navigate } from 'react-router-dom';

export default function DashboardPage() {
  // Redirect to the main app page
  return <Navigate to="/app" replace />;
}